function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#video-metric_svg__clip0_9867_224700)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.333,
  y: 0.732,
  width: 156,
  height: 87.753,
  rx: 6.71,
  fill: "#BCD5FA",
  fillOpacity: 0.08
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#video-metric_svg__clip1_9867_224700)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BCD5FA",
  fillOpacity: 0.08,
  d: "M.333.732h78.194v87.971H.333z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4038FF",
  d: "M.333 85.378h78.194v3.355H.333z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M140.333 10.713a6.666 6.666 0 00-6.666 6.666 6.666 6.666 0 1013.333 0 6.667 6.667 0 00-6.667-6.666zM132 17.379a8.333 8.333 0 0116.667 0 8.334 8.334 0 01-16.667 0z",
  fill: "#B5C1C9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M134.21 23.032a8.334 8.334 0 106.123-13.986v1.667a6.667 6.667 0 11-4.898 11.188l-1.225 1.13z",
  fill: "#4038FF"
}));

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.354,
  y: 98.547,
  width: 117.388,
  height: 10.062,
  rx: 3.354,
  fill: "#BBD9F6",
  fillOpacity: 0.13
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.354,
  y: 111.963,
  width: 85.525,
  height: 10.062,
  rx: 3.354,
  fill: "#BBD9F6",
  fillOpacity: 0.13
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "video-metric_svg__clip0_9867_224700"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.333,
  y: 0.732,
  width: 156,
  height: 87.753,
  rx: 6.71,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "video-metric_svg__clip1_9867_224700"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.333,
  y: 0.732,
  width: 156.387,
  height: 87.97,
  rx: 6.71,
  fill: "#fff"
})));

var SvgVideoMetric = function SvgVideoMetric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 123,
    viewBox: "0 0 157 123",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,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";
export { SvgVideoMetric as ReactComponent };